<h3 mat-dialog-title>Details Test Image</h3>
<mat-dialog-content>
    <aw-json-table [value]="data.test"></aw-json-table>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>Close</button>
</mat-dialog-actions>
